import {
	AccountBookPage,
	AccountBookCreateRemitPage,
	AccountBookOrderDetailPage,
	AccountBookSettleCashPage,
	AccountBookOverviewFilterPage,
	AccountBookOrderAllowanceRecordPage,
	AccountBookRemitAllowanceRecordPage,
	TriplicateInvoiceAllowanceOverviewPage,
} from "@icoach/accountBook";
import BatchPaymentBillingDetailPage from "@icoach/batchPayment/batchPaymentBillingDetail/BatchPaymentBillingDetailPage";
import {
	ACCOUNT_BOOK_ALL_ORDER_STAT,
	ACCOUNT_BOOK_ALL_ORDER_STAT_URL,
	ACCOUNT_BOOK_BULK_DEBIT,
	ACCOUNT_BOOK_BULK_DEBIT_BILLING_DETAIL,
	ACCOUNT_BOOK_BULK_DEBIT_URL,
	ACCOUNT_BOOK_ORDERS_ALLOWANCE,
	ACCOUNT_BOOK_ORDERS_ORDER,
	ACCOUNT_BOOK_ORDERS_OVERVIEW,
	ACCOUNT_BOOK_ORDERS_OVERVIEW_URL,
	ACCOUNT_BOOK_REMIT_ALLOWANCE,
	ACCOUNT_BOOK_REMIT_ORDERS_OVERVIEW,
	ACCOUNT_BOOK_REMIT_ORDERS_OVERVIEW_URL,
	ACCOUNT_BOOK_SITE_ORDER_STAT,
	ACCOUNT_BOOK_SITE_ORDER_STAT_URL,
	ACCOUNT_BOOK_TABS_SETTLE_CASH_PRICE,
	ACCOUNT_BOOK_OVERVIEW_FILTER,
	ACCOUNT_BOOK_ORDER_CREATE,
	ACCOUNT_BOOK_REMIT_CREATE,
	ACCOUNT_BOOK_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW,
} from "@icoach/router/routerPath";
import CreateOrderPage from "@icoach/accountBook/createOrder/CreateOrderPage";
import FRONT_KEY from "@constants/routerFrontKey";

const accountBookRouter = [
	{
		description: "營收管理",
		frontKey: "C6X01",
	},
	{
		description: "收入總覽",
		exact: true,
		path: ACCOUNT_BOOK_ORDERS_OVERVIEW,
		href: ACCOUNT_BOOK_ORDERS_OVERVIEW_URL,
		tabsIndex: "orders",
		as: AccountBookPage,
		frontKey: "C6X02",
	},
	{
		description: "匯款總覽",
		exact: true,
		path: ACCOUNT_BOOK_REMIT_ORDERS_OVERVIEW,
		href: ACCOUNT_BOOK_REMIT_ORDERS_OVERVIEW_URL,
		tabsIndex: "remit-orders",
		as: AccountBookPage,
		frontKey: "C6X07",
	},
	{
		description: "現場收入總覽",
		exact: true,
		path: ACCOUNT_BOOK_SITE_ORDER_STAT,
		href: ACCOUNT_BOOK_SITE_ORDER_STAT_URL,
		tabsIndex: "site-order-stat",
		as: AccountBookPage,
		frontKey: "C6X03",
	},
	{
		description: "總收入總覽",
		exact: true,
		path: ACCOUNT_BOOK_ALL_ORDER_STAT,
		href: ACCOUNT_BOOK_ALL_ORDER_STAT_URL,
		tabsIndex: "all-order-stat",
		as: AccountBookPage,
		frontKey: "C6X04",
	},

	{
		description: "新增收入",
		exact: true,
		path: ACCOUNT_BOOK_ORDER_CREATE,
		href: ACCOUNT_BOOK_ORDER_CREATE,
		as: CreateOrderPage,
		frontKey: "C6X06",
	},
	{
		description: "新增匯款",
		exact: true,
		path: ACCOUNT_BOOK_REMIT_CREATE,
		href: ACCOUNT_BOOK_REMIT_CREATE,
		as: AccountBookCreateRemitPage,
		frontKey: "C6X08",
	},
	{
		description: "訂單折讓歷史列表",
		exact: true,
		path: ACCOUNT_BOOK_ORDERS_ALLOWANCE,
		as: AccountBookOrderAllowanceRecordPage,
		frontKey: "C6X19",
	},
	{
		description: "匯款折讓歷史列表",
		exact: true,
		path: ACCOUNT_BOOK_REMIT_ALLOWANCE,
		as: AccountBookRemitAllowanceRecordPage,
		frontKey: "C6X20",
	},
	{
		description: "訂單明細頁",
		exact: true,
		path: ACCOUNT_BOOK_ORDERS_ORDER,
		as: AccountBookOrderDetailPage,
		frontKey: "C6X09",
	},
	{
		description: "每日結算",
		strict: true,
		path: ACCOUNT_BOOK_TABS_SETTLE_CASH_PRICE,
		as: AccountBookSettleCashPage,
		frontKey: "C6X10",
	},
	{
		description: "BILLING明細頁",
		exact: true,
		path: ACCOUNT_BOOK_BULK_DEBIT_BILLING_DETAIL,
		as: BatchPaymentBillingDetailPage,
		frontKey: "C6X11",
	},
	{
		description: "批次扣款",
		strict: true,
		path: ACCOUNT_BOOK_BULK_DEBIT,
		href: ACCOUNT_BOOK_BULK_DEBIT_URL,
		tabsIndex: "bulk-debit",
		as: AccountBookPage,
		frontKey: "C6X05",
	},
	{
		description: "快速查詢",
		exact: true,
		path: ACCOUNT_BOOK_OVERVIEW_FILTER(":quickType(1|2|3|4)"),
		href: ACCOUNT_BOOK_OVERVIEW_FILTER(2),
		as: AccountBookOverviewFilterPage,
		frontKey: "C6X18",
	},
	{
		description: "三聯發票折讓總覽",
		exact: true,
		path: ACCOUNT_BOOK_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW,
		href: ACCOUNT_BOOK_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW,
		as: TriplicateInvoiceAllowanceOverviewPage,
		frontKey: FRONT_KEY.C6X21,
	},
];

export default accountBookRouter;
